const actionListCount = (values: number[]) => values.length;

export default actionListCount;
